import React from 'react';

import styles from './DrawerBody.scss';

type Props = {
  children?: React.ReactNode;
};

function DrawerBody(props: Props) {
  const { children } = props;

  return <div className={styles.body}>{children}</div>;
}

export default React.memo(DrawerBody);
